module.exports = __webpack_public_path__ + "static/media/cover-insuring-concrete-slabs.677d5a85.jpg";